import { render, staticRenderFns } from "./filter-no-results.vue?vue&type=template&id=255ab400&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255ab400')) {
      api.createRecord('255ab400', component.options)
    } else {
      api.reload('255ab400', component.options)
    }
    module.hot.accept("./filter-no-results.vue?vue&type=template&id=255ab400&", function () {
      api.rerender('255ab400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/dataEntry/components/filter-no-results.vue"
export default component.exports